import { OpenInvoiceRow } from 'types/openInvoices';
import { portalAPI } from './portalAPI';

const APIOpenInvoicesSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getOpenInvoices: builder.query<OpenInvoiceRow[], { asOfDate: string }>({
            query: ({ asOfDate }) => `/v1/reports/open-invoices?asOfDate=${asOfDate}`,
            keepUnusedDataFor: 0,
        }),
    }),
    overrideExisting: false,
});

export const { useLazyGetOpenInvoicesQuery } = APIOpenInvoicesSlice;
